<h3 class="keep-lines">{{ 'auth.auth-layout.signup.title' | translate }}</h3>
<p>{{ 'auth.auth-layout.signup.desc' | translate }}</p>
